<style lang="scss" scoped>
.pre-container {
  width: 100%;
  .video {
    width: 100%;
  }
  .img-container {
    width: 100%;
    .img {
      width: 100%;
      object-fit: contain;
    }
  }
  .operate-container {
    position: fixed;
    bottom: 40px;
    display: flex;
    width: 100%;
    justify-content: center;
    &.vertical-put {
      top: 50%;
      transform: translateY(-50%);
    }
    .album, .take-photo {
      width: 268px;
      height: 72px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 28px;
      border-radius: 36px;
      &:hover {
        cursor: pointer;
      }
    }
    .album {
      color: #020202;
      margin-right: 26px;
      background-color: #ffffff;
      box-shadow: 0 4px 30px 0 rgba(143, 169, 206, 0.2);

    }
    .take-photo {
      color: #ffffff;
      background-color: #8FA9CE;
      box-shadow: 0 2px 15px 0 rgba(143,169,206,0.30);
    }
  }
  .brand-select-container {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.8);
    .know-container,
    .unknow-container {
      margin: 260px auto 0;
      width: 622px;
      height: 232px;
      overflow: hidden;
      position: relative;
      .img {
        height: 100%;
        width: 100%;
        position: absolute;
      }
      .title {
        margin-top: 84px;
        margin-left: 72px;
        font-size: 34px;
        color: #1d1d1d;
        font-weight: bold;
        position: absolute;
      }
      .desp {
        margin-top: 130px;
        margin-left: 72px;
        font-size: 24px;
        color: #999999;
        line-height: 34px;
        position: absolute;
      }
    }
    .unknow-container {
      margin: 24px auto 0;
    }
  }
  .brand-container {
    width: 494px;
    height: 104px;
    // border: 4px solid #fff;
    // border-radius: 30px;
    color: #333333;
    font-size: 34px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 40px;
    background-image: url("https://oss.turingsenseai.com/1607583187955684630.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .arrow-img {
      width: 50px;
      display: inline-block;
    }
  }
}
</style>

<template>
  <div class="pre-container">
  <div v-if="brandId" class="brand-container" @click="goSelectedThroughBrand">
    <!-- {/* <div className="filter-container"></div> */} -->
    <div>{{brandName}}
      <img src="https://oss.turingsenseai.com/1607582528381498466.png" class="arrow-img" />
    </div>
  <!-- {/* https://oss.turingsenseai.com/1607582528381498466.png */} -->
  </div>
    <div v-if="videoSupport" class="video-support-container">
      <video :style="`display: ${imageUrl ? 'none' : ''}`" :class="`video`" autoplay ref="video"></video>
    </div>
    <!-- <div class="video-unable-container"></div> -->
    <div v-if="imageUrl" class="img-container">
      <img :src="imageUrl" class="img">
    </div>
    <!-- <video :style="`display: ${imageUrl ? 'none' : ''}`" :class="`video`" autoplay ref="video"></video> -->
    <!-- <CoverView className="stick-figure">
                <CoverImage src={stickFigureIcon} className="stick-figure-img" />
              </CoverView>
              
              <CoverView className="bottom-text"> 
                请将商品边缘放置虚线内，拍摄正面清晰图
              </CoverView>

              <CoverView className="bottom-comps">
              <CoverView className="flash-lignt"> 
                <CoverImage className="flash-lignt-img" onClick={this.switchFlashLight.bind(this)} src={flashLight === 'off' ? noFlashIcon : flashIcon} />
              </CoverView>
              <CoverView className="tak-pic">
                <CoverImage className="tak-pic-img" onClick={this.takPic.bind(this)} src={takPicIcon} />
              </CoverView>
              <CoverView  className="ask-photo-album">
              <CoverImage className="ask-photo-album-img" onClick={this.askPhotoAblum.bind(this)} src={picAlbumIcon} />
              </CoverView> -->
    <div :class="`operate-container ${videoSupport ? '' : 'vertical-put'}`">
      <div v-if="videoSupport" class="album" @touchend="selectPicture">相册</div>
      <div v-if="videoSupport" class="take-photo" @touchend="takePhoto">{{imageUrl ? '重新拍照' : '按下拍照'}}</div>
      <div v-if="!videoSupport" class="take-photo"  @touchend="selectPicture">上传图片</div>
    </div>
    <canvas ref="canvas" style="display: none"></canvas>
    <input style="display: none" ref="picture" type="file" accept="image/*" @change="filesChange" />
    <div v-if="showSelect" class="brand-select-container">
      <div class="know-container" @click="goSelectedThroughBrand">
        <img class="img" src="https://oss.turingsenseai.com/1602740610726834971.png" />
        <div class="title">知道款式</div>
        <div class="desp">自主选择，更加精准哦~</div>
      </div>
      <div class="unknow-container" @click="closeSelectPanel">
        <img class="img" src="https://oss.turingsenseai.com/1602740701511323463.png" />
        <div class="title">不知道款式</div>
        <div class="desp">AI识包帮你解决</div>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadImage } from './../../common/api/common'
import { fetchSkcInfoByImg } from './../../common/api/ai-picture'
import { Toast } from 'vant'
// import { isTestEnv } from './../../common/constant'
import { H5PAGES_TARO_CONFIG } from './../../common/navigate-config'

export default {
  data () {
    return {
      videoStream: null, // 视频流
      useFrontCamera: false, // 前置摄像头标志
      constraints: { // 摄像头配置
        audio: false,
        video: {
          // height: {
          //   min: 1280,
          //   ideal: 1920,
          //   max: 2560,
          // },
          // width: {
          //   min: 720,
          //   ideal: 1080,
          //   max: 1440,
          // }
        },
      },
      imageUrl: '',
      videoSupport: false,
      showSelect: true,
      firstEnter: true,
      brandId: '',
      brandName: ''
    }
  },
  methods: {
    async init () {
        const { video } = this.$refs;
        // this.stopVideoStream();
        this.constraints.video.facingMode = this.useFrontCamera ? "user" : "environment";
        console.log((navigator.mediaDevices || navigator).getUserMedia)
        try {
          this.videoStream = await navigator.mediaDevices.getUserMedia(this.constraints);
          video.srcObject = this.videoStream;
        } catch (error) {
          console.log(error.constraint)
          if (error.constraint === 'width' || error.constraint === 'height') {
            // alert('您的设备拍摄分辨率较低，建议从相册选择')
            this.constraints.video = {}
            this.init()
          }
        }
    },
    takePhoto () {
      if (this.imageUrl) {
        this.imageUrl = '';
        // this.init()
        return
      }
       const takeToast = Toast.loading({
        message: '拍摄中...',
        forbidClick: true
      })
      const { canvas, video } = this.$refs;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext("2d").drawImage(video, 0, 0);
      this.imageUrl = canvas.toDataURL("image/png");
      takeToast.clear()
      this.uploadImg(this.imageUrl.split(',')[1])
    },
    selectPicture () {
      this.$refs.picture.click();
    },
    // 监听文件变化
    filesChange (e) {
      console.log(e.target.files);
      const fileList = e.target.files;
      const reader = new FileReader();
      reader.readAsDataURL(fileList[0]);
      reader.onload = (result) => {
        console.log(result);
        const imgB64 = result.target.result.split(',')[1];
        console.log(imgB64)
        this.uploadImg(imgB64);
      };
    },
    uploadImg (file) {
        const uploadToast = Toast.loading({
          message: '图片上传中...',
          forbidClick: true
        })
        uploadImage({ imgB64: file })
          .then(result => {
            if (result.errorCode === 0) {
              this.imageUrl = result.imageUrl
              this.getSkcInfo(this.imageUrl)
            }
          }).finally(() => {
            uploadToast.clear()
          })
    },
        // AI 识包 查询识包结果
    getSkcInfo (imageURL) {
      const getSkcToast = Toast.loading({
        message: '鉴别中...',
        forbidClick: true
      })
      const params = { imageURL }
      if (this.brandId) {
        params.brandId = this.brandId
      }
      fetchSkcInfoByImg(params)
        .then(result => {
          console.log(result)
          if (result && result.errorCode === 0) {
            result.holmesResult.forEach(item => {
              item.mainPic = item.mainPic.map(item1 => {
                return encodeURIComponent(item1)
              })
            })
            if (result.hasMatch) {
              this.$router.push({ path: `/ai-picture?type=0&logId=${result.logId}&data=${JSON.stringify(result.holmesResult)}` })
              // toWebview(H5_PAGES.aiPicture({type: 0, data: result.holmesResult, logId: result.logId}))
            } else {
              this.$router.push({ path: `/ai-picture/no-match?type=0&data=${JSON.stringify(result.holmesResult)}` })
              // toWebview(H5_PAGES.aiNoMatch({type: 0, data: result.holmesResult}))
            }
          }
          switch (result.errorCode) {
            case 10022 : Toast('系统错误，请重试'); break; // 系统错误  - 重试
            case 10023 : Toast('读取图片失败，请重新拍摄'); break; // 读取图片失败  -  重试\
            case 10025 : Toast('图片中没有检测到包，请重新拍摄'); break; // 图片中没有检测到包  - 重新拍摄
            case 10026 : Toast('图中的包没有相似图片，请重新拍摄'); break; // 图中的包没有相似图片  - 重新拍摄
          }
        }).finally(() => {
          getSkcToast.clear()
        })
    },
    // 关闭品牌选择
    closeSelectPanel () {
      this.showSelect = false
    },
    goSelectedThroughBrand () {
      // this.showSelect = false
      H5PAGES_TARO_CONFIG.toSelectBrand('shibao', 83, 'single-select')
    },
    refreshCache () {
      const brandCache = JSON.parse(localStorage.getItem('__selected_common_select'));
      if (brandCache && brandCache['data'] && brandCache['data'].categoryID) {
        this.brandId = brandCache['data'].categoryID
        this.brandName = brandCache['data'].name
        this.showSelect = false
        localStorage.removeItem('__selected_common_select');
        this.init();
      } else {
        this.brandId = this.brandId
      }
    }
  },
  mounted () {
    if (!this.videoSupport) return;
    this.init()
    this.refreshCache();
  },
  created () {
    window.removeEventListener('pageshow', () => {})
    const that = this;
    window.addEventListener('pageshow', this.refreshCache);
    const brandCache = JSON.parse(localStorage.getItem('__selected_common_select'));
    if (brandCache && brandCache['data'] && brandCache['data'].categoryID) {
      this.brandId = brandCache['data'].categoryID
      this.brandName = brandCache['data'].name
      this.showSelect = false
      localStorage.removeItem('__selected_common_select');
    }
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      this.videoSupport = true
    }
    this.firstEnter = false
  },
  beforeDestroy () {
    window.removeEventListener('pageshow', this.refreshCache);
  }
}
</script>
